import { Injectable } from "@angular/core";

import { UtenteDTO } from "@app/shared/dto/utenteDTO";
import { UtenteVO } from "@app/shared/vo/utenteVO";
import { MapperInterface } from "@app/shared/mapper/mapper-inteface";


@Injectable({
  providedIn: "root"
})
export class MapperIncaricato implements MapperInterface<UtenteDTO, UtenteVO> {
  constructor() { }

  convertVoToDto(utenteVO: UtenteVO): UtenteDTO {
    // console.log("[MapperUtente] utenteVO => utenteDTO");
    const utenteDTO = new UtenteDTO();
    if (utenteVO != null) {

      utenteDTO.id = utenteVO.id;
      utenteDTO.nome = utenteVO.nome;
      utenteDTO.cognome = utenteVO.cognome;

    }
    return utenteDTO || new UtenteDTO();
  }

  convertDtoToVo(utenteDTO: UtenteDTO): UtenteVO {
    /* console.log("[MapperUtente] utenteDTO => utenteVO");
    console.log("utenteDTO", utenteDTO); */

    const utenteVO = new UtenteVO();
    if (utenteDTO) {
      utenteVO.id = utenteDTO.id;
      utenteVO.nome = utenteDTO.nome;
      utenteVO.cognome = utenteDTO.cognome;


    }
    return utenteVO || new UtenteVO();
  }

  convertListVoToDto(utenteVOList: UtenteVO[]): UtenteDTO[] {
    const utenteDTOList = new Array<UtenteDTO>();
    if (utenteVOList != null && utenteVOList.length > 0) {
      utenteVOList.forEach(ufficioVO => {
        utenteDTOList.push(this.convertVoToDto(ufficioVO));
      });
    }
    return utenteDTOList || new Array<UtenteDTO>();
  }
  convertListDtoToVo(utenteDTOList: UtenteDTO[]): UtenteVO[] {
    if (utenteDTOList !== undefined) {
      return utenteDTOList.map(dto => this.convertDtoToVo(dto));
    } else {
      return new Array<UtenteVO>();
    }
  }
}
